<div #containerRef class="fcp-button-container">
    <div [ngClass]="{ 'fcp-button-container-content': menuStyle === fcpMenuStyle.Fixed }" #mainButton>
        <button
            fcp-button
            [attr.fcp-filled-button]="variant === fcpButtonVariants.Filled ? '' : null"
            [attr.fcp-outlined-button]="variant === fcpButtonVariants.Outlined ? '' : null"
            [attr.fcp-transparent-button]="variant === fcpButtonVariants.Transparent ? '' : null"
            class="fcp-button-container-main"
            [ngClass]="{
                'fcp-button-container-main-fluid': !iconOnly && menuStyle === fcpMenuStyle.Fluid,
                'fcp-button-container-main-transparent': variant === fcpButtonVariants.Transparent,
                'fcp-button-container-main-icon-only': iconOnly,
                'fcp-button-container-main-disabled': disabled
            }"
            [disabled]="disabled"
            [attr.size]="buttonSize"
            [attr.color]="color"
            (click)="onMainButtonClick()"
        >
            <span>{{ buttonText }}</span>
            <ng-content></ng-content>
        </button>
    </div>
    <div class="fcp-button-container-vertical-line" [ngClass]="separatorStyles"></div>
    <button
        fcp-button
        [attr.fcp-filled-button]="variant === fcpButtonVariants.Filled ? '' : null"
        [attr.fcp-outlined-button]="variant === fcpButtonVariants.Outlined ? '' : null"
        [attr.fcp-transparent-button]="variant === fcpButtonVariants.Transparent ? '' : null"
        [disabled]="disabled"
        [attr.color]="color"
        [attr.size]="buttonSize"
        class="fcp-button-container-secondary"
        [ngClass]="{
            'fcp-button-container-secondary-l': buttonSize === fcpButtonSize.Large,
            'fcp-button-container-secondary-m': buttonSize === fcpButtonSize.Medium,
            'fcp-button-container-secondary-transparent': variant === fcpButtonVariants.Transparent,
            'fcp-button-container-secondary-disabled': disabled
        }"
        [cdkMenuTriggerFor]="menu"
        [cdkMenuPosition]="menuPosition"
        (cdkMenuClosed)="onCdkMenuClosed()"
        (cdkMenuOpened)="onCdkMenuOpened()"
    >
        <fcp-icon
            *ngIf="menuPosition?.[0]?.originY === 'bottom' || menuPosition?.[0]?.originY === 'center'"
            [icon]="['fas', 'caret-down']"
        ></fcp-icon>
        <fcp-icon *ngIf="menuPosition?.[0]?.originY === 'top'" [icon]="['fas', 'caret-up']"></fcp-icon>
    </button>
</div>

<ng-template #menu>
    <div
        class="fcp-menu"
        [ngClass]="{
            'fcp-menu--prominent': menuColor === fcpMenuColor.Prominent,
            'fcp-menu--subtle': menuColor === fcpMenuColor.Subtle
        }"
        [style.width.px]="menuStyle === fcpMenuStyle.Fixed ? containerWidth : 'auto'"
        cdkMenu
    >
        <button
            *ngFor="let item of list; let idx = index"
            class="fcp-menu-item"
            [ngClass]="{
                'fcp-menu-item--disabled': item.disabled,
                'fcp-menu-item-l fcp-text-button-l': buttonSize === fcpButtonSize.Large,
                'fcp-menu-item-m fcp-text-button-m': buttonSize === fcpButtonSize.Medium
            }"
            [disabled]="item.disabled"
            cdkMenuItem
            (cdkMenuItemTriggered)="onMenuItemTriggered(item, idx)"
            [cdkMenuItemDisabled]="item.disabled"
        >
            {{ item.text }}
        </button>
    </div>
</ng-template>
